<div class="configuration-container">
    <a id="configurations" role="button" (click)="openConfiguration()">
        <img src="assets/images/icons/configuration_icon.svg" alt="configuration_icon" class="menu_icon">
    </a>
    <div class="configuration-dialog" *ngIf="showConfigurationDialog">
        <div class="menu-list" *ngFor="let menu of menuList">
            <div class="list cursor-pointer" (click)="menu.action()">{{ menu.labelKey | translate }}</div>
        </div>
    </div>
</div>

<div class="auth-change-password-modal w-100" *ngIf="authChangePasswordModal">
    <p-dialog
            [(visible)]="authChangePasswordModal"
            [modal]="true"
            [style]="{ top: '60px'}"
            [showHeader]="false"
            position="top"
            [draggable]="false">
        <div  class="app-change-password-container">
            <a id="close-change-password-modal-icon" class="close-change-password-modal-icon"
               (click)="closeChangeModalPassword()">
                <img src="assets/images/icons/close_dialog_icon.svg" alt="close">
            </a>
            <app-change-password
                    [cveUser]="cveUser"
                    [showCurrentPassword]="true"
                    [isModal]="true"
                    (changePasswordEmit)="changePassword($event)">

            </app-change-password>
        </div>
    </p-dialog>
</div>

<div class=" flex justify-content-center w-100">
    <p-dialog [(visible)]="changePassSuccessModalShow" [modal]="true" [style]="{ top: '100px' }"  [draggable]="false"
              [resizable]="false" [closable]="false" position="top" appendTo="body" >
        <app-password-success (closeModalEvent)="onCloseChangePassSuccess()"></app-password-success>
    </p-dialog>
</div>
